<template>
  <div>

    <Slide :right="true" :burgerIcon="false" :isOpen="isMenuOpen" @closeMenu="closeMenu">
      <a href="#schedule" class="nav-link link-effect-slideup" v-scroll-to="'#schedule'"> <span class="nav-link-inner" data-title="Planning">Planning</span> </a>
      <a href="#api" class="nav-link link-effect-slideup" v-scroll-to="'#api'"> <span class="nav-link-inner" data-title="API">API</span> </a>
      <a href="#pricing" class="nav-link link-effect-slideup" v-scroll-to="'#pricing'"> <span class="nav-link-inner" data-title="Prijzen">Prijzen</span> </a>
      <a href="#channels" class="nav-link link-effect-slideup" v-scroll-to="'#channels'"> <span class="nav-link-inner" data-title="Zenders &amp; omroepen">Zenders &amp; omroepen</span> </a>
      <a :href="docsUrl" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Documentatie">Documentatie</span> </a>
    </Slide>

    <!-- ======== @Region: body ======== -->
    <div class="page header-ontop header-compact-sticky page-index-event navbar-layout-default" data-colour-scheme="pink">

      <a id="#top" href="#content" class="sr-only">Skip to content</a>

      <!-- ======== @Region: #header ======== -->
      <div id="header">
        <div data-toggle="sticky" :class="{ 'is-sticky': scrolled }" style="top: 0px; left: 0px; width: 100%; position: fixed">
          <!--Header & Branding region-->
          <div class="header header-dark bg-dark border-primary sticky-bg-dark bg-op-1 border-op-4 sticky-bg-op-9" :style="[ scrolled ? {'background-color': 'rgba(52,58,64,.9) !important'} : {} ]">
            <!-- all direct children of the .header-inner element will be vertically aligned with each other you can override all the behaviours using the flexbox utilities (flexbox.htm) All elements with .header-brand & .header-block-flex wrappers will automatically be aligned inline & vertically using flexbox, this can be overridden using the flexbox utilities (flexbox.htm) Use .header-block to stack elements within on small screen & "float" on larger screens use .order-first or/and .order-last classes to make an element show first or last within .header-inner or .headr-block elements -->
            <div class="header-inner container">
              <!--branding/logo -->
              <div class="header-brand">
                <a class="header-brand-text" href="/" title="Home">
                  <h1 class="h2">
                    <span class="header-brand-text-alt">opTV</span>.nu
                  </h1>
                </a>
              </div>

              <!-- other header content -->
              <div class="header-block d-flex order-12 align-items-center">
                <a href="#top" class="btn btn-icon btn-white ml-2 order-12 d-lg-none" data-target=".navbar-main" data-direction="right" @click="isMenuOpen = true"> <i class="fa fa-bars"></i> </a>
                <router-link :to="{ name: 'login' }" class="btn btn-primary btn-sm text-uppercase font-weight-bold px-lg-3 py-lg-2 ml-lg-3">Inloggen</router-link>
              </div>

              <div class="navbar navbar-expand-md navbar-static-top">
                <!--everything within this div is collapsed on mobile-->
                <div class="navbar-main collapse">
                  <!--main navigation-->
                  <ul class="nav navbar-nav navbar-dark">
                    <li class="nav-item">
                      <a href="#schedule" class="nav-link link-effect-slideup" v-scroll-to="'#schedule'"> <span class="nav-link-inner" data-title="Planning">Planning</span> </a>
                    </li>
                    <li class="nav-item">
                      <a href="#api" class="nav-link link-effect-slideup" v-scroll-to="'#api'"> <span class="nav-link-inner" data-title="API">API</span> </a>
                    </li>
                    <li class="nav-item">
                      <a href="#pricing" class="nav-link link-effect-slideup" v-scroll-to="'#pricing'"> <span class="nav-link-inner" data-title="Prijzen">Prijzen</span> </a>
                    </li>
                    <li class="nav-item">
                      <a href="#channels" class="nav-link link-effect-slideup" v-scroll-to="'#channels'"> <span class="nav-link-inner" data-title="Zenders &amp; omroepen">Zenders &amp; omroepen</span> </a>
                    </li>
                    <li class="nav-item">
                      <a :href="docsUrl" class="nav-link link-effect-slideup"> <span class="nav-link-inner" data-title="Documentatie">Documentatie</span> </a>
                    </li>
                  </ul>
                </div>
                <!--/.navbar-collapse -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ======== @Region: #highlighted ======== -->
      <div id="highlighted" class="bg-black">
        <div class="overlay overlay-op-6 text-left" style="background: url('https://storage.googleapis.com/television-guide.appspot.com/jeshoots-com-606648-unsplash.jpg') no-repeat center center fixed;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-size: cover;">
          <div data-toggle="full-height" data-scroll="scrollax" class="container px-3 py-5 py-lg-7 flex-valign-b" data-animate="fadeIn" data-animate-delay="0.4" :style="{ height: window.height+'px' }">
            <h2 class="display-4 text-white font-weight-bold text-letter-spacing-xs text-uppercase mt-lg-7">
              API voor TV in Nederland
            </h2>
            <h3 class="text-grey font-weight-normal op-9">
              Alle omroepen, alle uitzendingen, alle data.
            </h3>
            <div class="mt-4"> <router-link :to="{ name: 'login' }" class="btn btn-primary font-weight-bold" data-animate="fadeIn" data-animate-delay="0.6">Inloggen</router-link> </div>
          </div>
        </div>
      </div>

      <!-- ======== @Region: #content ======== -->
      <div id="content" class="p-0 bg-white">
        <!-- schedule -->
        <div id="schedule" class="bg-white">
          <div class="container py-7">
            <h2 class="text-uppercase text-letter-spacing-xs my-0 text-primary font-weight-bold">
              Planning
            </h2>
            <p class="text-sm text-dark mt-0 mb-5">Een kleine greep uit het aanbod.</p>

            <!-- Planning -->
            <div class="row">
              <div class="col-lg-4 mb-3" v-for="(channel, i) in now.slice(0,13)" :key="i" v-if="channel.broadcasts.length > 0">
                <h4 class="mt-0 mb-3 text-dark op-8 font-weight-bold">
                  {{ channel.channel_id }}
                </h4>
                <ul class="list-timeline list-timeline-primary">
                  <li class="show list-timeline-item p-0 pb-3 d-flex flex-wrap flex-column">
                    <p class="my-0 text-dark flex-fw text-sm text-uppercase"><span class="text-inverse op-8">{{ channel.broadcasts[0].begin_time | unixToMoment }} - {{ channel.broadcasts[0].end_time | unixToMoment }}</span> - {{ channel.broadcasts[0].title }}</p>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>

        <!-- API -->
        <div id="api" class="bg-primary py-5">
          <div class="container text-white d-lg-flex justify-content-center">
            <h3 class="my-lg-0 mr-lg-3 font-weight-normal">
              Krijg toegang tot de API!
            </h3>
            <router-link :to="{ name: 'login' }" class="btn btn-primary btn-invert shadow-sm font-weight-bold">Inloggen</router-link>
          </div>
        </div>

        <hr class="my-0" />

        <!-- Pricing -->
        <div id="pricing" class="bg-light">
          <div class="container py-7">
            <h2 class="text-uppercase text-letter-spacing-xs my-0 text-primary font-weight-bold">
              Prijzen
            </h2>
            <p class="text-sm text-dark mt-0 mb-3">Beschikbaar in maandelijkse of jaarlijkse termijnen.</p>

            <!-- Monthly / yearly prices -->
            <div class="nav nav-pills nav-pills-border-bottom-inside nav-pills-border-lg flex-row d-inline-flex" role="tablist">
              <span class="nav-link text-uppercase font-weight-bold px-4" :class="[ pricing === 'monthly' ? 'active' : '' ]" @click="pricing = 'monthly'">Maandelijks</span>
              <span class="nav-link text-uppercase font-weight-bold px-4" :class="[ pricing === 'yearly' ? 'active' : '' ]" @click="pricing = 'yearly'">Jaarlijks</span>
            </div>

            <!-- Pricing stack -->
            <div class="row pricing-stack mt-3">
              <div class="col-md-4 d-flex" v-for="(tier, i) in tiers" :key="i">
                <div class="card border-0 text-center flex-ew">
                  <div class="bg-primary py-4 text-white">
                    <h4 class="my-0">
                      {{ tier.title }}
                    </h4>
                    <h2 class="price-digits display-4 price-early-bird font-weight-bold my-0">
                      €{{ tier[pricing] }}
                    </h2>
                  </div>
                  <div class="card-body">
                    <p class="text-sm mt-0 mb-4 text-grey-dark op-8" v-for="(feature, j) in tier.features" :key="j">{{ feature }}</p>

                    <router-link :to="{ name: 'login' }" class="btn btn-primary px-5 font-weight-bold text-uppercase">Inloggen</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="my-0" />

        <!-- Channels -->
        <div id="channels" class="pos-relative">
          <div class="container py-7">
            <h2 class="text-uppercase text-letter-spacing-xs my-0 text-primary font-weight-bold">
              Zenders & oproepen
            </h2>
            <p class="text-sm text-dark mt-0 mb-5">In de API</p>
            <div class="row">
              <div class="col-6 col-lg-3 d-flex" v-for="(channel, i) in channels" :key="i">
                <div class="card mb-3 border-0 flex-ew">
                  <div class="card-body bg-light">
                    <h5 class="card-title mb-1">
                      {{ channel }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- #Content -->
      <!-- ======== @Region: #footer ======== -->
      <footer id="footer" class="py-3 py-4 border-primary">
        <div class="container">
          <div class="row">
            <div class="col-md-4 d-md-flex justify-content-start align-items-center flex-row">
              <p class="mb-0 text-sm">&copy; opTV.nu 2018-{{ new Date().getFullYear() }}</p>
            </div>
            <div class="col-md-4 d-md-flex justify-content-center align-items-center flex-row">
              <a href="#top" class="text-white op-7 p-2" title="Back to top"><i class="fa fa-chevron-up"></i></a>
            </div>
            <div class="col-md-4 d-md-flex justify-content-end align-items-center flex-row">
              <ul class="list-inline footer-links mb-0 text-sm float-md-right">
                <li class="list-inline-item"><router-link :to="{ name: 'terms-of-service' }">Voorwaarden</router-link></li>
                <li class="list-inline-item"><router-link :to="{ name: 'privacy-policy' }">Privacy</router-link></li>
                <li class="list-inline-item"><router-link :to="{ name: 'contact' }">Contact</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <!--Hidden elements - excluded from jPanel Menu on mobile-->
      <div class="hidden-elements jpanel-menu-exclude"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { Slide } from 'vue-burger-menu'

export default {
  metaInfo: {
    title: 'Index'
  },
  components: {
    Slide
  },
  data () {
    return {
      docsUrl: process.env.DOCS_URL,
      isMenuOpen: false,
      scrolled: false,
      window: {
        width: 0,
        height: 0
      },
      now: [],
      pricing: 'monthly',
      tiers: [
        {
          title: 'Gratis',
          monthly: 0,
          yearly: 0,
          features: [
            'REST API toegang',
            '1 sleutel',
            '50 verzoeken per maand',
            'Heldere documentatie'
          ]
        },
        {
          title: 'Basis',
          monthly: 9.99,
          yearly: 99.99,
          features: [
            'REST API toegang',
            '3 sleutels',
            '750 verzoeken per maand',
            'Heldere documentatie',
            'Versleutelde verbindingen via HTTPS',
            'Technische ondersteuning'
          ]
        },
        {
          title: 'Standaard',
          monthly: 19.99,
          yearly: 199.99,
          features: [
            'REST API toegang',
            'GRPC interface toegang',
            '5 sleutels',
            '5.000 verzoeken per maand',
            'Health check endpoints',
            'Heldere documentatie',
            'Versleutelde verbindingen via HTTPS',
            'Technische ondersteuning'
          ]
        },
        {
          title: 'Premium',
          monthly: 49.99,
          yearly: 499.99,
          features: [
            'REST API toegang',
            'GRPC interface toegang',
            '10 sleutels',
            '10.000 verzoeken per maand',
            'Health check endpoints',
            'Hoogste prioriteit',
            'Eigen server',
            'Heldere documentatie',
            'Versleutelde verbindingen via HTTPS',
            'Technische ondersteuning'
          ]
        }
      ],
      channels: [
        '192TV',
        '24Kitchen',
        '3Sat',
        'AMC',
        'ARD',
        'AT5',
        'Al Jazeera',
        'Animal Planet',
        'Arte',
        'BBC Entertainment',
        'BBC First',
        'BBC World News',
        'BBC four',
        'BBC one',
        'BBC two',
        'BR Alpha',
        'BVN-TV',
        'Bayerisches Fernsehen',
        'Boomerang',
        'Brava NL Klassiek',
        'Brazzers TV',
        'CAZ',
        'CBS Reality',
        'CNBC Europe',
        'CNN',
        'Canvas',
        'Cartoon Network',
        'Comedy Central',
        'Comedy Central Extra',
        'Comedy Central Family',
        'Crime & Investigation Network',
        'DJAZZ.tv',
        'Deutsche Welle',
        'Discovery Channel',
        'Discovery HD Showcase',
        'Discovery Science',
        'Discovery World',
        'Disney Channel',
        'Disney Channel (D)',
        'Disney XD',
        'E! Entertainment',
        'Een',
        'Euronews',
        'Eurosport 1',
        'Eurosport 2',
        'FOX Sports 1',
        'FOX Sports 2',
        'FOX Sports 3',
        'FOX Sports 4',
        'FOX Sports 5',
        'Family7',
        'FashionTV',
        'Film1 Action',
        'Film1 Drama',
        'Film1 Family',
        'Film1 Premiere',
        'Film1 Sundance',
        'Food Network',
        'Fox',
        'France 2',
        'HR Fernsehen',
        'History',
        'ID',
        'KPN Presenteert',
        'Kabel Eins',
        'Ketnet',
        'L1 TV',
        'LiteTV',
        'MDR',
        'MTV',
        'MTV Live HD',
        'Mezzo',
        'Motors TV',
        'N24',
        'NDR Fernsehen',
        'NH Nieuws',
        'NPO 1',
        'NPO 1 extra',
        'NPO 2',
        'NPO 2 extra',
        'NPO 3',
        'NPO Politiek',
        'Nat Geo Wild',
        'National Geographic Channel',
        'National Geographic HD Benelux',
        'Nautical Channel',
        'Net5',
        'Nick Jr.',
        'Nickelodeon',
        'ONS',
        'OUTTV',
        'Omroep Brabant',
        'Omroep Flevoland',
        'Omroep Gelderland',
        'Omroep West',
        'Omroep Zeeland',
        'Omrop Fryslan',
        'Pebble TV',
        'Pro Sieben',
        'Q2',
        'RAI UNO',
        'RBB Fernsehen',
        'RTL 4',
        'RTL 5',
        'RTL 7',
        'RTL 8',
        'RTL Crime',
        'RTL II',
        'RTL Lounge',
        'RTL Television',
        'RTL Z',
        'RTV Drenthe',
        'RTV Noord',
        'RTV Oost',
        'RTV Rijnmond',
        'RTV Utrecht',
        'SBS6',
        'SBS9',
        'SWR Fernsehen RP',
        'Sat 1',
        'Sky News',
        'Spike',
        'Spike',
        'Sport1',
        'Super RTL',
        'TELE 5',
        'TLC',
        'TV Oranje',
        'TV5 Monde',
        'TVE Internacional',
        'Travel Channel',
        'VH-1',
        'VH1 Classic',
        'VOX',
        'VTM',
        'Veronica',
        'Vier',
        'Vijf TV',
        'Vitaya',
        'WDR',
        'ZDF',
        'Ziggo Sport',
        'Ziggo Sport Golf',
        'Ziggo Sport Racing',
        'Ziggo Sport Select',
        'Ziggo Sport Voetbal',
        'n-tv'
      ]
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.$nextTick(() => {
      this.getNow()
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    handleScroll () {
      this.scrolled = window.scrollY > 0
    },
    closeMenu () {
      this.isMenuOpen = false
    },
    getNow () {
      axios
        .get(`${process.env.API_URL}/v1/now`)
        .then(res => (this.now = res.data))
        .catch(err => console.log(err))
    }
  },
  filters: {
    unixToMoment (val) {
      return moment.unix(val).format('HH:mm')
    }
  }
}
</script>

<style>
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
  cursor: pointer;
}
.bm-burger-bars {
  background-color: #373a47;
}
.line-style {
  position: absolute;
  height: 20%;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background-color: rgb(63, 63, 65);
  overflow-x: hidden;
  padding-top: 60px;
  transition: 0.5s;
}
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 20px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue